import { Link } from "react-router-dom";
import styled from "styled-components";
import NewFooter from "../../components/Footers/NewFooter";
import NewNavbar from "../../components/Navbar/NewNavbar";
import Seo from "../../components/Seo/Seo";

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Hero = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 120px 24px 80px;
`;

const Code = styled.p`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 8px;
`;

const Title = styled.h1`
  font-size: 40px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    font-size: 30px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: #4a4a4a;
  max-width: 540px;
  margin: 0 auto 32px;
`;

const Actions = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
`;

const Button = styled(Link)`
  display: inline-block;
  padding: 14px 32px;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
    text-decoration: none;
  }
`;

const PrimaryButton = styled(Button)`
  background: var(--brand-primary, #0e7e7a);
  color: #ffffff;
`;

const SecondaryButton = styled(Button)`
  background: #f3f4f6;
  color: #1a1a1a;
`;

const NotFoundPage = () => {
  return (
    <PageContainer>
      <Seo
        title="Page Not Found | Listino"
        description="The page you're looking for doesn't exist. Explore Listino's listing prep for real estate agents."
        noindex
        prerenderStatusCode={404}
      />
      <NewNavbar />
      <Hero>
        <Code>404</Code>
        <Title>We couldn't find that page</Title>
        <Subtitle>
          The page you're looking for may have moved or no longer exists. Let's get you back to
          something useful.
        </Subtitle>
        <Actions>
          <PrimaryButton to="/">Go to homepage</PrimaryButton>
          <SecondaryButton to="/get-started">Get started</SecondaryButton>
        </Actions>
      </Hero>
      <NewFooter />
    </PageContainer>
  );
};

export default NotFoundPage;
